import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "15",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#7540EE",
      d: "m7.522 14.06 2.536-2.358 4.314 3.111a1.01 1.01 0 0 0 .906.133.95.95 0 0 0 .39-.25.86.86 0 0 0 .211-.396l3.098-13.222a.83.83 0 0 0-.026-.473.9.9 0 0 0-.283-.393 1.01 1.01 0 0 0-.965-.149L.322 6.526a.47.47 0 0 0-.233.16.42.42 0 0 0 0 .511c.058.075.139.13.233.16L4.939 8.72l10.32-5.918a.16.16 0 0 1 .104-.015.15.15 0 0 1 .089.051.136.136 0 0 1-.005.183L7.405 9.889l-.339 3.996a.23.23 0 0 0 .036.148.25.25 0 0 0 .122.098q.08.03.162.01a.26.26 0 0 0 .136-.081"
    }, null, -1)
  ])))
}
export default { render: render }